<template>
  <div class="container">

    <el-form ref="searchForm" :model="searchData" inline>
      <el-form-item label="UID">
        <el-input v-model.number="searchData.user_id" size="mini" />
      </el-form-item>

        <el-form-item label="审核状态:">
          <el-select v-model="searchData.status" placeholder="请选择" >
            <el-option
                v-for="item in dataStatus"
                :key="item.key"
                :label="item.name"
                :value="item.key">
            </el-option>
          </el-select>     
        </el-form-item>

      <el-form-item>
        <el-button size="mini" @click="handleSearch">
            查找
        </el-button>
      </el-form-item>
    </el-form>

    <el-table
      :data="data"
      @sort-change="handlerSort"
      :default-sort = "{prop: 'id', order: 'descending'}"
    >
      <el-table-column
        prop="user_id"
        label="UID"
      />

      <el-table-column
        prop="nickname"
        label="微信昵称"
      />
    
      <el-table-column
        prop="avatar"
        label="微信头像">
        
        <template slot-scope="scope">
          <el-image
            :src="scope.row.avatar || ''"
            style="width: 40px; height: 40px;"
          />
        </template>
      </el-table-column>

      <el-table-column
        prop="status"
        label="状态"
        :formatter="(_, _1, v) => { return getStatusName(v) }"
      />

      <el-table-column
        label="操作"
      >
        <template slot-scope="scope">
          <el-button v-if="isShowViewDetail(scope.row.status)" type="primary" size="mini" @click="handleViewDetail(scope.row)" >审核</el-button>
          <el-button v-else type="default" size="mini" @click="handleViewDetail(scope.row)" >详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <page-bar
        :currentPageCount="data.length"
        @page-changed="loadData"
    />

    <el-dialog 
      title="详情"
      :visible.sync="showViewDetail"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="handleViewDetailDialogClose"
    >
      
      <el-form ref="editForm" :model="editForm" :rules="editRules" label-position="right">
        
        <el-form-item prop="user_id" label="UID:" label-width="150px">
          <el-input v-model="detail.user_id" style="width:50%" disabled/>
        </el-form-item>

        <el-form-item label="姓名:" label-width="150px">
          <el-input v-model="detail.card_name" style="width:50%" disabled/>
        </el-form-item>

        <el-form-item label="身份证号:" label-width="150px">
          <el-input v-model="detail.card_number" style="width:50%" disabled/>
        </el-form-item>

        <el-form-item label="人像面:" label-width="150px">
            <el-image v-model="cardPositiveSrc" :src="'data:image/jpeg;base64,' + cardPositiveSrc"/>
        </el-form-item>

        <el-form-item label="国徽面:" label-width="150px">
          <el-image :src="'data:image/jpeg;base64,' + cardBackSrc"/>
        </el-form-item>

        <div v-if="isShowViewDetail(detail.status)">
            
            <el-form-item prop="result" label="审核状态:" label-width="150px">
                <el-select v-model="editForm.result" placeholder="请选择">
                    <el-option
                        v-for="item in identityStatus"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>     
            </el-form-item>

            <el-form-item v-if="!editForm.result" prop="verify_error_no" label="失败原因:" label-width="150px">
                <el-select v-model="editForm.verify_error_no" placeholder="请选择">
                    <el-option
                        v-for="item in errors"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select> 
            </el-form-item>

            <el-form-item v-if="editForm.result && editForm.qualification_number" prop="institutions" label="所属机构:" label-width="150px">
                <el-input v-model="editForm.institutions" style="width:50%" />
            </el-form-item>

            <el-form-item v-else-if="editForm.result" label="所属机构:" label-width="150px">
                <el-input v-model="editForm.institutions" style="width:50%"/>
            </el-form-item>

            <el-form-item v-if="editForm.result && editForm.institutions" prop="qualification_number" label="从业资格证编号:" label-width="150px">
                <el-input v-model="editForm.qualification_number" style="width:50%" />
            </el-form-item>

            <el-form-item v-else-if="editForm.result" label="从业资格证编号:" label-width="150px">
                <el-input v-model="editForm.qualification_number" style="width:50%" />
            </el-form-item>
        </div>
        
        <div v-else>
            <el-form-item label="审核状态:" label-width="150px">
                <el-select v-model="detail.status" placeholder="" style="width:50%" disabled>
                    <el-option
                        v-for="item in dataStatus"
                        :key="item.key"
                        :label="item.name"
                        :value="item.key">
                    </el-option>
                </el-select>     
            </el-form-item>

            <el-form-item label="失败原因:" label-width="150px">
                <el-select v-model="detail.additional.verify_error_no" placeholder="" style="width:50%" disabled>
                    <el-option
                        v-for="item in errors"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select> 
            </el-form-item>

            <el-form-item label="所属机构:" label-width="150px">
                <el-input v-model="detail.additional.institutions" style="width:50%" disabled />
            </el-form-item>

            <el-form-item label="从业资格证编号:" label-width="150px">
                <el-input v-model="detail.additional.qualification_number" style="width:50%" disabled />
            </el-form-item>
        </div>

      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="showViewDetail = false">取 消</el-button>
        <el-button v-if="isShowViewDetail(detail.status)" type="primary" @click="handleSave">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import PageBar from "../ui/PageBar"
  import request from "@/api/request"

  const initForm = {
    user_id: null,
    result: null,
    verify_error_no: null,
    qualification_number: null,
    institutions: null
  },

  rules = {
    result: [
    {
        required: true,
        message: "名称不能为空"
    }
    ],
    verify_error_no: [
    {
        required: true,
        message: "名称不能为空"
    }
    ],
    qualification_number: [
    {
        required: true,
        message: "名称不能为空"
    }
    ],
    institutions: [
    {
        required: true,
        message: "名称不能为空"
    }
    ]
  },

  initDetail = {
    additional: {
        verify_error_no: null,
        institutions: null,
        qualification_number: null
    },
    card_back: null,
    card_name: null,
    card_number: null,
    card_positive: null,
    id: null,
    status: null,
    user_id: null
  }
  export default {
    name: 'IdentityList',
    components: { PageBar },
    data () {
      return {
        data: [],
        filter: {},
        searchData: {},
        currentRange: [],
        sort: [],
        detail: { ...initDetail },
        errors: [],
        cardBackSrc: null,
        cardPositiveSrc: null,
        dataStatus: [
            { key: '0', name: '创建' },
            { key: '100', name: '重置' },
            { key: '200', name: 'AI审核' },
            { key: '920', name: 'AI审核失败' },
            { key: '250', name: 'AI审核成功' },
            { key: '300', name: '人工审核' },
            { key: '930', name: '人工审核失败' },
            { key: '350', name: '人工审核成功' }
        ],
        identityStatus: [
            {
                value: true,
                label: '审核通过'
            }, 
            {
                value: false,
                label: '审核失败'
            }
        ],
        editForm: { ...initForm },
        showViewDetail: false
      }
    },
    computed: {
        editRules: function () {
            return { ...rules }
        }
    },
    created() {
        this.loadData([0, 10])
    },
    methods: {
      async loadData(range) {
        this.currentRange = range
        request.uc
            .post("identity_list", Object.assign(
                {range: range}, 
                this.searchData.status ? { status: Number(this.searchData.status) } : {},
                this.searchData.user_id ? { user_id: this.searchData.user_id } : {}
                ))
            .then(r => {
                this.data = r.data.list;
                this.loading = false;
            });
      },
      handleViewDetail(row) {
        this.editForm = { ...initForm }
        this.getDetail(row.user_id)
        this.getIndentityError()
        this.cardPositiveSrc = null
        this.cardBackSrc = null
        this.showViewDetail = true
      },
      handleSearch() {
        this.loadData(this.currentRange)
      },
      getDetail(id) {
        this.detail = { ...initDetail }
        request.uc
            .post("identity_get", {
                user_id: id
            })
            .then(response => {
                this.detail = response.data
                this.detail.status = this.detail.status + ''
                this.getFileSrc()
            })
      },
      getIndentityError() {
        request.tools
            .post("defined_get", {
                prefix: 'USER_IDENTITY_ERROR_MSG_'
            })
            .then(response => {
                this.errors = []
                if (response.data && response.data.length > 0) {
                    Object.keys(response.data[0]).forEach(key => this.errors.push({value: Number(key), label: response.data[0][key]}))
                }              
            })
      },

      handleSave() {
        this.$refs.editForm.validate(async valid => {
          if (valid) {
            this.$refs.editForm.clearValidate()
            let data = {}
            data.user_id = this.detail.user_id
            Object.keys(this.editForm).forEach(key => {
                if (this.editForm[key] || key === 'result') {
                    data[key] = this.editForm[key]
                }
            })
            
            await request.uc
              .post("identity_manual_verify", data)
              .then(() => {
                this.$message.success("添加成功")
              })
            this.showViewDetail = false;
            this.loadData(this.currentRange)
          }
        })
      },
      handleViewDetailDialogClose() {
        this.$refs.editForm.clearValidate()
      },
      handlerSort(column) {
        this.sort = [
          {
            field: column.prop,
            reverse: column.order === 'descending'
          }
        ]
      },
      getStatusName(key) {
        const ret = this.dataStatus.find(item => item.key === key + '')
        return ret ? ret.name : ''
      },
      isRequiredError() {
          return this.editForm ? !this.editForm.result : false
      },
      isShowViewDetail(key) {
          return key === '300' || key === 300
      },
      getFileSrc() {
          request.tools
            .post("file_get", {
                files : [
                    {
                        type: 'id_card',
                        path: this.detail.card_positive
                    },
                    {
                        type: 'id_card',
                        path: this.detail.card_back
                    }
                ]
            })
            .then(response => {
                this.cardPositiveSrc = response.data.list[0] ? response.data.list[0] : ''
                this.cardBackSrc = response.data.list[1] ? response.data.list[1] : ''
            })
      }
    }
  }
</script>
